import { trimStringToFullWords } from '../../../utils/trimStringToFullWords'

const DEFAULT_INSURANCE_DESCRIPTION =
  'This center accepts insurance, exact cost can vary depending on your plan and deductible'
const defaultEmptyArray = []
const DEFAULT_CENTER = {
  term_descriptions: defaultEmptyArray,
  short_description: '',
  insurance_description: DEFAULT_INSURANCE_DESCRIPTION
}

const MAX_INSURANCE_DESCRIPTION_LENGTH = 220

/**
 * Returns a custom description for a center based on a list of terms.
 *
 * @param {Object} options - The options for getting the custom description.
 * @param {Object} options.center - The center to get the custom description for. Defaults to DEFAULT_CENTER.
 * @param {Array} options.termsList - The list of terms to match against the center's term_descriptions. Defaults to an empty array.
 * @returns {string} The custom description if a term in termsList matches a term in the center's term_descriptions, otherwise the center's default description.
 */
const getCenterDescription = ({
  center = DEFAULT_CENTER,
  termsList = defaultEmptyArray,
  showInsuranceDescription = false
} = {}) => {
  const term_descriptions =
    center.term_descriptions || center.termDescription || defaultEmptyArray
  const short_description =
    center.short_description || center.shortDescription || ''
  const insurance_description =
    center.insurance_description ||
    center.insuranceDescription ||
    DEFAULT_INSURANCE_DESCRIPTION

  if (showInsuranceDescription) {
    return `"${trimStringToFullWords(
      insurance_description || DEFAULT_INSURANCE_DESCRIPTION,
      MAX_INSURANCE_DESCRIPTION_LENGTH
    )}..."`
  }

  if (!Array.isArray(term_descriptions) || !Array.isArray(termsList)) {
    return short_description?.trim() + '...'
  }

  const customTermDescription = term_descriptions.find((termDescription) => {
    return termsList.flat().some((term) => term === termDescription.term_title)
  })

  if (customTermDescription) {
    return customTermDescription.description?.trim() + '...'
  }

  if (!short_description) {
    return ''
  }

  return short_description?.trim() + '...'
}

export default getCenterDescription
